module.exports = __webpack_public_path__ + "img/78c6fa1.jpg";